import { render } from "./addPeople.vue?vue&type=template&id=7d89aa12&scoped=true"
import script from "./addPeople.vue?vue&type=script&lang=js"
export * from "./addPeople.vue?vue&type=script&lang=js"

import "./addPeople.vue?vue&type=style&index=0&id=7d89aa12&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d89aa12"]])

export default __exports__